import { catchError } from '../../utils/CatchError/CatchError'
import { apiService } from '../_config_/apiservice'

// Chaves do ConfiguracaoEnum (backend). O path do endpoint usa o nome literal
// da constante — errar o nome resulta em 400. Mantenha em sincronia com a API.
export type TemplateConfigNome =
  | 'TEMPLATE_ASSUNTO_EMAIL_PEDIDO'
  | 'TEMPLATE_EMAIL_PEDIDO'
  | 'TEMPLATE_WHATSAPP_PEDIDO'
  | 'TEMPLATE_PDF_PEDIDO'

// O endpoint /app/configuracao/{nome} trafega texto puro (text/plain), NÃO JSON.
// Por isso desligamos as transformações padrão do axios:
//  - transformResponse identidade: evita JSON.parse mangling do HTML/texto.
//  - transformRequest identidade + Content-Type text/plain no PUT: evita o
//    JSON.stringify do axios, que salvaria o valor com aspas literais.

export const getTemplate = async (
  nome: TemplateConfigNome
): Promise<{ valor: string } | { message: string }> => {
  try {
    const result = await apiService.get(`app/configuracao/${nome}`, {
      transformResponse: data => data,
    })
    if (result.status === 200) {
      return { valor: result.data ?? '' }
    }
  } catch (error) {
    return catchError(error)
  }
  return { message: 'Algo de errado aconteceu!' }
}

export const getTemplatePadrao = async (
  nome: TemplateConfigNome
): Promise<{ valor: string } | { message: string }> => {
  try {
    const result = await apiService.get(`app/configuracao/${nome}/padrao`, {
      transformResponse: data => data,
    })
    if (result.status === 200) {
      return { valor: result.data ?? '' }
    }
  } catch (error) {
    return catchError(error)
  }
  return { message: 'Algo de errado aconteceu!' }
}

export const salvarTemplate = async (
  nome: TemplateConfigNome,
  valor: string
): Promise<{ sucesso: true } | { message: string }> => {
  try {
    const result = await apiService.put(`app/configuracao/${nome}`, valor, {
      headers: { 'Content-Type': 'text/plain' },
      transformRequest: data => data,
    })
    if (result.status === 200) {
      return { sucesso: true }
    }
  } catch (error) {
    return catchError(error)
  }
  return { message: 'Algo de errado aconteceu!' }
}
